"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _OverflowText = _interopRequireDefault(require("./OverflowText"));

var _helpers = require("../../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function TableRow(_ref) {
  var record = _ref.record,
      maxIndex = _ref.maxIndex;
  return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Row, {
    className: "data-workflow-table__row " + (record.belowSample ? 'table__sample-small' : '')
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Cell, {
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(_OverflowText["default"], {
    value: record.questionLabel
  })), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Cell, {
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(_OverflowText["default"], {
    value: record.answerLabel
  })), record.belowSample ? /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Cell, {
    textAlign: "center",
    colSpan: 4,
    width: 10
  }, "Data source sample size is below the reportable threshold.") : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Cell, {
    width: 7
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "data-workflow-table__index-bar",
    style: {
      width: record.index / maxIndex * 100 + '%'
    }
  }, Math.round(record.index))), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Cell, {
    width: 1,
    style: {
      textAlign: 'center'
    }
  }, (0, _helpers.formatAsPercent)(record.shareOfAudience)), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Cell, {
    width: 1,
    style: {
      textAlign: 'center'
    }
  }, (0, _helpers.formatAsPercent)(record.shareOfProperty)), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Cell, {
    width: 1,
    style: {
      textAlign: 'center'
    }
  }, (0, _helpers.formatAsThousands)(record.population))));
}

var _default = TableRow;
exports["default"] = _default;